
import { defineComponent, SetupContext, ref, computed } from "vue";
import NativeClient from "@/client/native-client";
import {PLATE_DELETE_FOOD_STATUS} from "@/types/pantry";

export default defineComponent({
  name: "PantryDetailMenuView",
  components: {
  },
  props: {
  },
  setup(props, context: SetupContext) {
    const clickItem = (foodStatus: number) => {
      context.emit("click-item", foodStatus);
    };
    return {
      clickItem,
      PLATE_DELETE_FOOD_STATUS
    };
  }
});
